
  import React from "react"
  import Component from "/Users/pkimbrel/Local/Content/paulkimbrel-com/src/layouts/index.js"
  import data from "/Users/pkimbrel/Local/Content/paulkimbrel-com/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js